import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8l2 8l2 -8","key":"svg-0"}]]

const IconLetterVSmall = createReactComponent('outline', 'letter-v-small', 'LetterVSmall', __iconNode);

export default IconLetterVSmall;